import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../common/CmnContext';
import { SaleListContext } from '../SaleListContext';
import Loading from '../../../common/loading/Loading';

export function SaleListLoading(props: any) {
  const isPc = useContext(cmnContext).isPc;
  const isLoading = useContext(SaleListContext).isLoading;

  const isFirstLoad = props.isFirstLoad;
  const isResetLoading = props.isResetLoading;


  useEffect(() => {
    if(!isFirstLoad || isResetLoading || isLoading) {
      // ローディング中はスクロール不可
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isFirstLoad, isResetLoading, isLoading])


  return (
    <>
    {(!isFirstLoad || isResetLoading) &&
      <div style={{
        display: 'flex',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <Loading
          width={isPc? '40%' : '30%'}
          isWhite={true}
        />
      </div>
    }
    </>
  );
}